import React from "react";
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";
import Icon from "../Utils/Icon";
import Amount from "../Utils/Amount";

import classes from "./styles.module.css";

function formatKopecks(value) {
    if (value === null || value === undefined) {
        return "—";
    }
    var floatVal = Number(value) / 100;
    return floatVal.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) + " ₽";
}

function ProjectMobileCard({data, hasExtendedBalances, hasCrm, showAverageBill}) {
    var safeData = data || {};
    var balance = Array.isArray(safeData.balance) ? safeData.balance : [];
    var averageBill = Array.isArray(safeData.averageBill) ? safeData.averageBill : [];

    function renderBalance() {
        if (!balance.length) return <span>—</span>;

        return balance.map(function (el, index) {
            var currency = Object.keys(el)[0];
            return (
                <span key={index}>
                    <Amount amount={el[currency]} currency={currency}/>
                </span>
            );
        });
    }

    function renderAverageBill(type) {
        if (!averageBill.length) return <span>—</span>;

        return averageBill.map(function (v, index) {
            var currency = Object.keys(v)[0];
            var value = v[currency] && v[currency][type];
            return value ? (
                <Amount key={index} currency={currency} amount={value.toFixed(2)}/>
            ) : (
                <span key={index}>—</span>
            );
        });
    }

    return (
        <div className={classes.MobileCard}>
            <div className={classes.MobileCardHeader}>
                <div className={classes.MobileProjectName}>
                    <Icon className={classes.FavoriteIcon} color="#f44336" icon="star-full" size={"12px"}/>
                    {safeData.displayName}
                </div>
                <Link to={"/projects/settings/" + safeData.uuid} className={classes.MobileSettingsLink}>
                    <Icon className={classes.SettingsIcon} color="#2479E0" icon="settings" size={"16px"}/>
                    <FormattedMessage id="ProjectsWidget.table.settings" defaultMessage="Настройки"/>
                </Link>
            </div>

            <a className={classes.MobileWebsite} target="_blank" rel="noopener noreferrer" href={safeData.url}>
                {safeData.url ? safeData.url.replace(/^([a-zA-Z]+):\/\//, "") : "—"}
            </a>

            <div className={classes.MobileMetrics}>
                <div>
                    <span className={classes.MobileLabel}>
                        <FormattedMessage id="ProjectsTable.table.balance" defaultMessage="Баланс"/>
                    </span>
                    <span className={classes.MobileValue}>{renderBalance()}</span>
                </div>

                {hasExtendedBalances ? (
                    <React.Fragment>
                        <div>
                            <span className={classes.MobileLabel}>
                                {hasCrm ? "Резервный" : (
                                    <FormattedMessage
                                        id="ProjectsTable.table.settlementBalance"
                                    defaultMessage="Возмещение"
                                    />
                                )}
                            </span>
                            <span className={classes.MobileValue}>{formatKopecks(safeData.settlementBalance)}</span>
                        </div>
                        <div>
                            <span className={classes.MobileLabel}>
                                <FormattedMessage
                                    id="ProjectsTable.table.actualBalance"
                                    defaultMessage="Действительный"
                                />
                            </span>
                            <span className={classes.MobileValue}>{formatKopecks(safeData.actualBalance)}</span>
                        </div>
                    </React.Fragment>
                ) : null}

                {showAverageBill ? (
                    <React.Fragment>
                        <div>
                            <span className={classes.MobileLabel}>
                                <FormattedMessage id="ProjectsWidget.table.payments" defaultMessage="Платежи"/>
                            </span>
                            <span className={classes.MobileValue}>{renderAverageBill("payment")}</span>
                        </div>
                        <div>
                            <span className={classes.MobileLabel}>
                                <FormattedMessage id="ProjectsWidget.table.payouts" defaultMessage="Выплаты"/>
                            </span>
                            <span className={classes.MobileValue}>{renderAverageBill("payout")}</span>
                        </div>
                    </React.Fragment>
                ) : null}

                {!hasExtendedBalances && !showAverageBill ? (
                    <div>
                        <span className={classes.MobileLabel}>
                            <FormattedMessage id="ProjectsTable.table.status" defaultMessage="Статус"/>
                        </span>
                        <span className={classes.MobileValue}>
                            {safeData.status === 1 ? (
                                <FormattedMessage id="ProjectsTable.status.active" defaultMessage="Активен"/>
                            ) : (
                                <FormattedMessage id="ProjectsTable.status.blocked" defaultMessage="Заблокирован"/>
                            )}
                        </span>
                    </div>
                ) : null}
            </div>
        </div>
    );
}

export default ProjectMobileCard;



// WEBPACK FOOTER //
// ./src/Components/ProjectMobileCard/index.js